import { useEffect } from 'react';

import Modal from './modal';

import './styles.css';

import Logo from './images/logo.jpg';
import AccountingSadness from './images/accounting-sadness.png';

export const Step2 = ({onNext}) => {
  useEffect(() => {
    const goNextTimeout = setTimeout(() => {
      onNext();
    }, 4000);
    return () => clearTimeout(goNextTimeout);
  }, [onNext]);

  return (
    <Modal className="step-2">
      <img src={Logo} alt="Logo" className="onboarding-logo" />
      <h4>Market Games</h4>
      <p className="fade-in-up-small">
        Accounting can be a struggle if you don’t know <b>the basics</b>.
      </p>
      <img src={AccountingSadness} alt="Accounting Sadness" className="accounting-sadness" />
    </Modal>
  )
};